import { SelectedMultiOption } from '@weareopenr/component-library/build/components/MultiSelect/utilities';
import { INestedVenueCategory, IVenueCategory } from 'src/api/getVenueCategories';

export const venueCategoriesToSelectOptions = (nestedCategories: INestedVenueCategory[]): SelectedMultiOption[] => {
  const mapCategory = (category: INestedVenueCategory): SelectedMultiOption => ({
    id: category.category_id,
    label: category.name,
    display_order: category.display_order,
    children: category.children?.map(mapCategory) || [],
  });

  return nestedCategories?.map(mapCategory) || [];
};

export const venuesInSelectedCategories = (selected: string[] = [], categories: IVenueCategory[] = []): string[] => {
  if (selected.length === 0) return [];

  const venues = categories
    .filter(({ category_id }) => selected.includes(category_id))
    .flatMap(({ venue_ids }) => venue_ids);
  return Array.from(new Set(venues));
};
